import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";


type ItemSeleccionado = {
    ID: number;
    CodeID: number;
    Name: string;
    value: number;
};

interface Props {
    jsonProps?: string;
    onChange?: (value: string) => void;
    CodeSelector?: number
    labelSelector?: string
}

export const ListJSONPuntajeQualityInspectionItems = ({ jsonProps = "", onChange, CodeSelector, labelSelector }: Props) => {
    const [current, setCurrent] = useState<Partial<ItemSeleccionado>>({});
    const [lista, setLista] = useState<ItemSeleccionado[]>([]);

    useEffect(() => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed as ItemSeleccionado[]);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    }, []);

    useEffect(() => {
        onChange?.(JSON.stringify(lista));
    }, [lista]);

    const create = () => {
        if (!current.ID || !current.CodeID || !current.Name || !current.value) {
            toast.error("Debe seleccionar un dato valido.");
            return;
        }

        if (lista.some(i => i.ID === current.ID)) {
            toast.warn("Este dato ya está agregada.");
            return;
        }

        setLista(prev => [
            ...prev,
            { ID: current.ID, CodeID: current.CodeID, Name: current.Name, value: current.value } as ItemSeleccionado
        ]);
    };

    const deleteItem = (index: number) => {
        setLista(prev => prev.filter((_, i) => i !== index));
    };

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-5">
                        <label>{labelSelector}</label>
                        <SelectTHConstantsValue
                            label=" "
                            code={CodeSelector}
                            returnType="Object"
                            value={current.ID}
                            onChange={(e: any) => {
                                if (!e) {
                                    setCurrent({ ...current, CodeID: null, ID: null, Name: "" });
                                    return;
                                }
                                const { IDTHConstantsValue, CodeID, Name } = e;
                                setCurrent({
                                    ID: IDTHConstantsValue,
                                    CodeID,
                                    Name
                                });
                            }}
                        />
                    </div>

                    <div className="col-md-5">
                        <label>Puntaje</label>
                        <input type="number" className="form-control" value={current.value} onChange={(e) => {
                            const valor = e.target.value ? parseInt(e.target.value) : null
                            setCurrent({ ...current, value: valor })
                        }} />
                    </div>

                    <div className="col-md-2">
                        <BasicButton useMargin eventClick={() => { create() }} icon="ri-file-add-line">
                            Agregar
                        </BasicButton>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Area de Defecto</th>
                            <th>Puntaje</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={`${item.ID}-${index}`}>
                                <td>{index + 1}</td>
                                <td>{item.Name}</td>
                                <td >{item.value}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                    >
                                        Eliminar
                                    </BasicButton>
                                </td>
                            </tr>
                        ))}

                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={4} className="text-center">
                                    No hay elementos agregados
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
